import PropTypes from 'prop-types';
import React from 'react';
import List from '@material-ui/core/List';
import { Divider, makeStyles } from '@material-ui/core';
import { useLocation, matchPath } from 'react-router-dom';
import { withRoutes } from '~/modules/common/routes';
import { useMeContext } from '~/modules/me';
import MenuItem from '../MenuItem';

const useStyles = makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(1)
  }
}));

export const SchedulingMenuItems = ({ routes }) => {
  const {
    featureFlags: {
      isPsaPrpWcagFixesQ4Enabled,
      isPsaPrpEmbedSchedulesInPolarisEnabled
    }
  } = useMeContext();
  const location = useLocation();
  const classes = useStyles();

  const { scheduleManagement: scheduleManagementRoute } = routes;

  if (!isPsaPrpEmbedSchedulesInPolarisEnabled || !scheduleManagementRoute) {
    return null;
  }

  const menuItems = (
    <>
      <Divider component="li" className={classes.divider} light />
      <MenuItem
        path={scheduleManagementRoute.path}
        icon={<scheduleManagementRoute.icon />}
        title={<scheduleManagementRoute.title />}
        selected={!!matchPath(location.pathname, scheduleManagementRoute)}
        divider={scheduleManagementRoute.showDivider}
      />
    </>
  );

  return isPsaPrpWcagFixesQ4Enabled ? (
    menuItems
  ) : (
    <List disablePadding>{menuItems}</List>
  );
};

SchedulingMenuItems.propTypes = {
  routes: PropTypes.object
};

export default withRoutes(SchedulingMenuItems);
